import moment from 'moment-timezone';

type Props = { date: string; format: string; timezone?: string; locale?: string };

const getFormatDate = ({ date, format, locale, timezone }: Props): string => {
	let formatDate = moment(date);

	if (timezone) {
		formatDate = formatDate.tz(timezone);
	}
	if (locale) {
		formatDate = formatDate.locale(locale);
	}

	return formatDate.format(format);
};

export default getFormatDate;
